import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { testimonialsData } from '../../data/mock';

export const Testimonials = () => {
  return (
    <section className="py-20 md:py-32 px-6 bg-[#f9f8f3]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="mb-4">
            <span className="inline-block bg-[#8B6F47] text-white px-6 py-2 text-sm font-medium tracking-wide uppercase">
              200+ People Transformed
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-4">
            Real People. Real Transformation.
          </h2>
          <p className="text-lg md:text-xl text-[#666666] max-w-3xl mx-auto">
            These are the stories of people who decided to invest in themselves—and everything changed.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonialsData.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 relative"
            >
              <Quote className="text-[#8B6F47] opacity-20 absolute top-6 right-6" size={48} />
              
              <div className="relative z-10">
                <p className="text-base md:text-lg text-[#666666] leading-relaxed italic">
                  "{testimonial.quote}"
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
